import React, {useEffect, useState, useMemo, useRef} from "react";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye,faPlus, faMinus, faImage, faFilePowerpoint } from "@fortawesome/free-solid-svg-icons";
// import { Button, Modal } from "react-bootstrap";
// import Modal from "admin/common/Modal";
import { Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { apiUrl, assetsUrl, fileserverUrl } from "../../config/Config";
import moment from 'moment';
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import JSZip from "jszip";
import UserDetailsModal from "../components/UserDetailsModal";
ModuleRegistry.registerModules([ClientSideRowModelModule]);

const Subscriptions = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const userdata = useSelector((store) => store.userReducer.userdata);
    const [showloding, setshowloding] = useState(false);
    const [showmodal, setshowmodal] = useState(false);
    const [editshowmodal, seteditshowmodal] = useState(false);
    const [selectedid, setselectedid] = useState(0);

    const [title, settitle] = useState("");
    const [layouttype, setlayouttype] = useState("");
    const [pptfile, setpptfile] = useState("");
    const [searchtags, setsearchtags] = useState([]);
    const [image, setimage] = useState("");


    const selectedidRef = useRef(0);
    selectedidRef.current = selectedid;

    var prevtableobj = [
      {
        "title": "",
        "file": null
      }
    ];

    const [tabledataarr, settabledataarr] = useState(prevtableobj);

    const tabledataarrRef = useRef(prevtableobj);
    tabledataarrRef.current = tabledataarr;

    const [forceupdate, setforceupdate] = useState(false);



    const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  const paginationPageSizeSelector = useMemo(() => {
    return [10, 20, 50, 100];
  }, []);

  const [showcandidatedetailsmodal, setshowcandidatedetailsmodal] = useState(false);
  const [selectedcandidateid, setselectedcandidateid] = useState("");
  const selectedcandidateidRef = useRef("");
  selectedcandidateidRef.current = selectedcandidateid;

  const handleplusicon = () => {
    var prevobj = 
      {
        "title": "",
        "file": null
      };
    var prevdata = tabledataarrRef.current;
    prevdata.push(prevobj);
    settabledataarr(prevdata);
    setforceupdate(!forceupdate);
  }

  const handleminusicon = () => {
    var prevdata = tabledataarrRef.current;
    if(prevdata?.length == 1) {

    } else {
      prevdata.pop();
      settabledataarr(prevdata);
      setforceupdate(!forceupdate);
    }
   
  }

  const handleinputtablechange = (index, key, value) => {
    var prevdata = tabledataarrRef.current;
    prevdata[index][key] = value;
    settabledataarr(prevdata);
    setforceupdate(!forceupdate);
  }

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log("Called", reader);
        baseURL = reader.result;
        // console.log(baseURL);
        resolve(baseURL);
      };
      // console.log(fileInfo);
    });
  };

  const handleinputchange = async (file) => {
    setpptfile(file);
    if (!file) {
      return;
    }

    // setProperties(null);
    // setError('');

    if (!file.name.endsWith('.pptx')) {
      // setError('Invalid file type. Please upload a .pptx file.');
      return;
    }

    try {
      const arrayBuffer = await file.arrayBuffer();
      const zip = await JSZip.loadAsync(arrayBuffer);
      
      const corePropsFile = zip.file('docProps/core.xml');

      if (corePropsFile) {
        const content = await corePropsFile.async('string');
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(content, 'application/xml');
        
        const getTagValue = (tagName) => {
            const elements = xmlDoc.getElementsByTagName(tagName);
            return elements.length > 0 ? elements[0].textContent : 'N/A';
        };

        const extractedProps = {
          title: getTagValue('dc:title'),
          author: getTagValue('dc:creator'),
          // ⬇️ This is the new line to get the keywords
          keywords: getTagValue('cp:keywords'), 
          lastModifiedBy: getTagValue('cp:lastModifiedBy'),
          revision: getTagValue('cp:revision'),
          createdDate: new Date(getTagValue('dcterms:created')).toLocaleString(),
          modifiedDate: new Date(getTagValue('dcterms:modified')).toLocaleString(),
        };

        console.log('extractedProps >>', extractedProps)
        var keywords = getTagValue('cp:keywords');
        var keywordsarr = keywords.split(', ');
        if(keywordsarr?.length > 0) {
          setsearchtags(keywordsarr);
        } else {
          
        }
        

        // setProperties(extractedProps);
      } else {
        // setError('Could not find core properties file (docProps/core.xml) in the presentation.');
      }
    } catch (e) {
      console.error(e);
      // setError('Failed to read or process the PPTX file.');
    }

  };

  const handleimagetablechange = async (index, key, file) => {
    var obj = {};
    await getBase64(file).then((result) => {
      obj["name"] = file.name;
      obj["image"] = result;
    });
    handleinputtablechange(index, key, obj);
    // console.log('obj >>', obj);
    // setimage(obj);
  };

  const submithandle = async () => {
    console.log('title >>', title);
    console.log('pptfile >>', pptfile);
    console.log('image >>', image);
    if (title && pptfile && image) {
      setshowloding(true);
      // console.log('image >>', image);
      // console.log('image name >>', image.name);
      try {
        const pngData = new FormData();
        pngData.append("files", image);
        const pngRes = await axios.post(fileserverUrl, pngData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        console.log('pngRes?.data >>', pngRes?.data);
        if(pngRes?.data?.uploaded?.length > 0) {

        } else {
          alert('error uploading image file.')
          return;
        }

        // For PPT
        const pptData = new FormData();
        pptData.append("files", pptfile);
        const ppptRes = await axios.post(fileserverUrl, pptData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        console.log('ppptRes?.data >>', ppptRes?.data);
        if(ppptRes?.data?.uploaded?.length > 0) {

        } else {
          alert('error uploading ppt file.')
          return;
        }

        // Create Layout
        var prevtags = searchtags?.length > 0 ? searchtags.join(",") : "";
        const formData = new FormData();
        formData.append("title", title);
        formData.append("layouttype", layouttype);
        formData.append("pptfile", pptfile.name);
        formData.append("image", image.name);
        formData.append("searchtags", prevtags);

        console.log('formData >>', formData);

        const headers = {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .post(apiUrl + "createlayout", formData, headers)
          .then((res) => {
            // console.log('res >>>', res.data)
            if (res.data.status == "success") {
              window.location.reload();
              setshowmodal(false);
              settitle("");
              setlayouttype("");
              setsearchtags([]);
              setpptfile("");
              fetchallcourses();
              setshowloding(false);
            } else {
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/admin/login');
              } else {
                  alert(res.data.message);
              }
              setshowloding(false);
            }
          })
          .catch((err) => {
            setshowloding(false);
            alert(err.message);
          });
      } catch (error) {
        console.error("Error creating layout:", error);
      }

      
      setshowloding(false);
    } else {
      alert("Mandatory fields cannot be empty.");
    }
  };

  const edithandle = async () => {
    console.log("selectedidRef.current >>", selectedidRef.current);
    if (title) {
      setshowloding(true);
      console.log('image >>', image ? image?.name : "");
      try {
        if(image) {
          const pngData = new FormData();
          pngData.append("files", image);
          const pngRes = await axios.post(fileserverUrl, pngData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          console.log('pngRes?.data >>', pngRes?.data);
          if(pngRes?.data?.uploaded?.length > 0) {
  
          } else {
            alert('error uploading image file.')
            return;
          }
        } else {

        }

        if(pptfile) {
           // For PPT
        const pptData = new FormData();
        pptData.append("files", pptfile);
        const ppptRes = await axios.post(fileserverUrl, pptData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        console.log('ppptRes?.data >>', ppptRes?.data);
        if(ppptRes?.data?.uploaded?.length > 0) {

        } else {
          alert('error uploading ppt file.')
          return;
        }
        } else {

        }
       

       
      } catch (error) {
        console.error("Error creating layout:", error);
      }

      var prevtags = searchtags?.length > 0 ? searchtags.join(",") : "";
      const formData = new FormData();
      formData.append("id", selectedidRef.current);
      formData.append("title", title);
      formData.append("layouttype", layouttype);
      formData.append("pptfile", pptfile ? pptfile?.name : "");
      formData.append("image", image ? image?.name : "");
      formData.append("searchtags", prevtags);
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .post(apiUrl + "updatelayout", formData, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            seteditshowmodal(false);
            window.location.reload();
            settitle("");
            setlayouttype("");
            setsearchtags([]);
            setpptfile("");
            setselectedid(0);
            fetchallcourses();
            setshowloding(false);
          } else {
            if (res.data.message == "invalid user") {
              dispatch({ type: "userdata", payload: {} });
              navigate("/admin/login");
            } else {
              alert(res.data.message);
            }
            setshowloding(false);
          }
        })
        .catch((err) => {
          setshowloding(false);
          alert(err.message);
        });
      
      setshowloding(false);
    } else {
      setshowloding(false);
      alert("Empty Field");
    }
    setshowloding(false);
  };

    const clickhandle = () =>  {
        // console.log('Mission Launched')
      }

      const editlocation = async(data) => {
        setselectedid(data?.id);
        console.log('editlocation data >>', data);
        setimage("");
        setpptfile("");
        settitle(data?.title);
        setlayouttype(data?.layouttype);
        if(data?.searchtags) {
          setsearchtags(data?.searchtags.split(','));
        } else {
          setsearchtags([])
        }
        // setname(data?.name);
        seteditshowmodal(true);
      }

      const deletecourse = async (id, title) => {
        console.log('id >>', id);
        const result = window.confirm("Are you sure you want to delete layout : " + title);
        if (result) {
          var data = JSON.stringify({
            id: id,
          });
          const headers = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + userdata?.token,
            },
          };
          let resp = await axios
            .post(apiUrl + "deletelayout", data, headers)
            .then((res) => {
              if (res.data.status == "success") {
                fetchallcourses();
              } else {
              }
            })
            .catch((err) => {
              alert(err.message);
            });
        } else {
          // User clicked Cancel or closed the dialog
          // console.log("User clicked Cancel");
        }
      };

      const defaultColDef = {
        flex: 1,
      };

      const handlesubmitquestion = () => {
        console.log('hello world!!');
      }

      const handleCheckboxChange = async(t, id, title) => {
        // console.log('t >>', t.target.checked);
        if(!t.target.checked) {
          const result = window.confirm("Are you sure you want to disable user : " + title);
          if(result) {

          } else {
            return
          }
        }
        
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    var data = {
      'id': id,
      'status': t.target.checked ? 'true': 'false'
    }
    let resp = await axios
    .post(apiUrl + "updateuserstatus", data, headers)
    .then((res) => {
      if (res.data.status == "success") {
        fetchallcourses();
        setshowloding(false);
      } else {
        if(res.data.message == "invalid user") {
          dispatch({ type: "userdata", payload: {} })
          navigate('/admin/login');
        } else {
          alert(res.data.message);
        }
      }
    })
    .catch((err) => {
      alert(err.message);
    });
  setshowloding(false);
    console.log('data >>', data);
      }

      const handleviewdetails = (id) => {
        // console.log('id >>', id)
        // navigate('/candidate-details', { state: { userid: id } });
        setselectedcandidateid(id);
        setTimeout(() => {
          setshowcandidatedetailsmodal(true);
        }, 1000);
      }


    const fetchallcourses = async () => {
        setshowloding(true);
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .get(apiUrl + "getallregisteredusers", headers)
          .then((res) => {
            if (res.data.status == "success") {
              // console.log('getallcategories >>', res.data);
              var prevdata = res.data.data;
              if(prevdata?.length > 0) {
                var columnsarr = [];
                var hidecolumns = ['id', 'created_at', 'updated_at', 'sort', 'image', 'status', 'categoryid', 'description', 'facebook', 'twitter', 'linkedin', 'instagram', 'pinterest', 'slug', 'points', 'tabledata', 'pptfile', 'searchtags'];
                var columns = Object.keys(prevdata[0]);
                // console.log('columns  >>>', columns );
                for(var i = 0; i < columns?.length;i++) {
                  if(!hidecolumns.includes(columns[i])) {
                    var obj = {};
                    obj.field = columns[i];
                    // console.log('obj >>', obj)
                    columnsarr.push(obj);
                  }
                }

                //Image
                if (columns.includes("image")) {
                  var imageobj = {
                    field: "image",
                    headerName: "Tumbnail",
                    cellRenderer: (props) => {
                      // console.log('image props >>', props);
                      return (
                        <>
                          {props?.data?.image ? (
                            <Link
                              // to={assetsUrl + "images/" + props?.data?.image}
                              to={assetsUrl + props?.data?.image}
                              target="_blank"
                              style={{
                                maxWidth: 35,
                                paddingLeft: 10,
                                paddingRight: 10,
                                cursor: "pointer",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faImage}
                                className="sidebaricons"
                                style={{ color: "blue", fontSize: 18 }}
                              />
                              {/* <iframe
                                src={"https://view.officeapps.live.com/op/view.aspx?src="+assetsUrl + "ppt/" + props?.data?.pptfile}
                                width="100%"
                                height="600px"
                                frameborder="0"
                              ></iframe> */}
                            </Link>
                          ) : null}
                        </>
                      );
                    },
                    cellRendererParams: {
                      onClick: clickhandle,
                    },
                  };
                  columnsarr.push(imageobj);
                }
               

                //PPT
                if (columns.includes("pptfile")) {
                  var imageobj = {
                    field: "pptfile",
                    headerName: "PPT File",
                    cellRenderer: (props) => {
                      // console.log('image props >>', props);
                      return (
                        <>
                          {props?.data?.pptfile ? (
                            <Link
                              to={assetsUrl + props?.data?.pptfile}
                              target="_blank"
                              style={{
                                maxWidth: 35,
                                paddingLeft: 10,
                                paddingRight: 10,
                                cursor: "pointer",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faFilePowerpoint}
                                className="sidebaricons"
                                style={{ color: "blue", fontSize: 18 }}
                              />
                              {/* <iframe
                                src={"https://view.officeapps.live.com/op/view.aspx?src="+assetsUrl + "ppt/" + props?.data?.pptfile}
                                width="100%"
                                height="600px"
                                frameborder="0"
                              ></iframe> */}
                            </Link>
                          ) : null}
                        </>
                      );
                    },
                    cellRendererParams: {
                      onClick: clickhandle,
                    },
                  };
                  columnsarr.push(imageobj);
                }

                //created_at
            //     if(columns.includes('created_at')) {
            //       var craetddatobj = 
            //   {
            //     field: "Date",
            //     headerName: "Date",
            //     cellRenderer: (props) => {
            //       // console.log('date props >>', props);
            //       return (
            //              <div>
            //               <p className="created_at_value">{moment(props?.data?.created_at).format('DD MMMM YYYY HH:mm')}</p>
            //             </div>
            //       )
            //     },
            //     cellRendererParams: {
            //       onClick: clickhandle,
            //     },
            //   }
            //   columnsarr.push(craetddatobj);
            //     }

                 //status
             var statusobj = {
               field: "status",
               headerName: "Status",
               maxWidth: 100,
               cellRenderer: (props) => {
                 // console.log('props >>', props?.data)
                 return (
                   <div className="d-flex">
                     <div class="form-check">
                       <input
                         onChange={(t) => {
                           handleCheckboxChange(
                             t,
                             props?.data?.id,
                             props?.data?.fullname
                           );
                         }}
                         type="checkbox"
                         class="form-check-input tableformcheck"
                         id="check1"
                         name="option1"
                         value="something"
                         style={{ marginTop: 12 }}
                         checked={
                           props?.data?.status == "true" ||
                           props?.data?.status == true
                             ? true
                             : false
                         }
                       />
                     </div>
                   </div>
                 );
               },
             };
             columnsarr.push(statusobj);

             //details
              var detailsobj = 
              {
                field: "details",
                headerName: "Details",
                maxWidth: 100,
                cellRenderer: (props) => {
                  
                  return (
                    <div
                          onClick={() => {
                            // editlocation(props?.data);
                            // console.log('props >>', props?.data);
                            handleviewdetails(props?.data?.id)
                          }}
                          style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                        >
                          <FontAwesomeIcon
                            icon={faEye}
                            className="sidebaricons"
                            style={{ color: "blue" }}
                          />
                        </div>
                  )
                },
                cellRendererParams: {
                  onClick: clickhandle,
                },
              }
              columnsarr.push(detailsobj);
              
                //edit
            //   var editobj = 
            //   {
            //     field: "edit",
            //     headerName: "Edit",
            //     cellRenderer: (props) => {
                  
            //       return (
            //         <div
            //               onClick={() => {
            //                 editlocation(props?.data);
            //                 // console.log('props >>', props?.data);
            //               }}
            //               style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
            //             >
            //               <FontAwesomeIcon
            //                 icon={faPenToSquare}
            //                 className="sidebaricons"
            //                 style={{ color: "blue" }}
            //               />
            //             </div>
            //       )
            //     },
            //     cellRendererParams: {
            //       onClick: clickhandle,
            //     },
            //   }
            //   columnsarr.push(editobj);

                //delete
                // var deleteobj = 
                // {
                //   field: "delete",
                //   headerName: "Delete",
                //   cellRenderer: (props) => {
                    
                //     return (
                //       <div
                //             onClick={() => {
                //               deletecourse(props?.data?.id, props?.data?.title);
                //               // console.log('props >>', props?.data);
                //             }}
                //             style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                //           >
                //             <FontAwesomeIcon
                //               icon={faTrash}
                //               className="sidebaricons"
                //               style={{ color: "red" }}
                //             />
                //           </div>
                //     )
                //   },
                //   cellRendererParams: {
                //     onClick: clickhandle,
                //   },
                // }
                // columnsarr.push(deleteobj);
                setColDefs(columnsarr);
                setRowData(prevdata);
              } else {
                setColDefs([]);
                setRowData([]);
              }
              
              // setcoursesdata(res.data.data);
            } else {
              // alert(res.data.message);
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/admin/login');
              } else {
                alert(res.data.message);
              }
            }
          })
          .catch((err) => {
            alert(err.message);
          });
          setshowloding(false);
      };
    useEffect(() => {
            if (userdata && Object.keys(userdata).length > 0) {
              //   fetchdata();
              fetchallcourses();
            } else {
              navigate("/admin/login");
            }
          }, []);
    return (
      <div className="adminmainpagelayout">
        {/* <div className="productstogglebar mt-2">
          <div
            className="filterdiv couponfilterdiv"
            onClick={() => {
              setimage("");
              setpptfile("");
              setshowmodal(true);
            }}
          >
            <FontAwesomeIcon
              icon={faPlus}
              className="iconstyles"
              style={{ color: "#64748B" }}
            />
            <p>Add Layout</p>
          </div>
        </div> */}

        <div
          className={"ag-theme-quartz"}
          style={{ width: "100%", height: 500, marginTop: 15 }}
        >
          <AgGridReact
            // modules={AllModules}
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            suppressRowClickSelection={true}
            groupSelectsChildren={true}
            rowSelection={"multiple"}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={paginationPageSizeSelector}
            // onGridReady={onGridReady}
          />
        </div>

        {/*Add modal */}
        <Modal
          show={showmodal}
          onHide={() => setshowmodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>Create New Layout</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div className="">
                <label className="addproduct-label">Title *</label>
                <input
                  value={title}
                  onChange={(t) => {
                    settitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Layout Title"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Layout Type</label>
                <select className="form-control" value={layouttype} onChange={(t) => {setlayouttype(t.target.value)}}>
                  <option value={""} selected disabled >Select layout</option>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
                </select>
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Upload Thumbnail *</label>
                <input
                  onChange={(t) => {
                    setimage(t.target.files[0]);
                  }}
                  accept="image/*"
                  type="file"
                  className="form-control addproductinput"
                  placeholder=""
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Upload PPT *</label>
                <input
                  onChange={(t) => {
                    handleinputchange(t.target.files[0]);
                  }}
                  accept=".ppt,.pptx"
                  type="file"
                  className="form-control addproductinput"
                  placeholder="Category Image"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">
                  Tags (Type point and press enter to add another point)
                </label>
                <TagsInput
                  value={searchtags}
                  onChange={(options) => {
                    setsearchtags(options);
                  }}
                  placeholder={"Enter Points"}
                  inputProps={{
                    className: "react-tagsinput-input",
                    placeholder: "",
                  }}
                  className="form-control tagsinputbox"
                />
              </div>

              <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    submithandle();
                  }}
                >
                  <p>Submit</p>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/*Edit modal */}
        <Modal
          show={editshowmodal}
          onHide={() => seteditshowmodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>Edit Layouts</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div className="webadmin-modalmainbody">
              <div className="">
                <label className="addproduct-label">Title</label>
                <input
                  value={title}
                  onChange={(t) => {
                    settitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Layout Title"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Layout Type</label>
                <select className="form-control" value={layouttype} onChange={(t) => {setlayouttype(t.target.value)}}>
                  <option value={""} selected disabled >Select layout</option>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
                </select>
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Upload Thumbnail</label>
                <input
                  onChange={(t) => {
                    setimage(t.target.files[0]);
                  }}
                  accept="image/*"
                  type="file"
                  className="form-control addproductinput"
                  placeholder=""
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Upload PPT</label>
                <input
                  onChange={(t) => {
                    handleinputchange(t.target.files[0]);
                  }}
                  accept=".ppt,.pptx"
                  type="file"
                  className="form-control addproductinput"
                  placeholder="Category Image"
                />
              </div>
              {/* <div>
              <iframe
                                src={"https://docs.google.com/gview?src=http://127.0.0.1:8000/storage/uploads/ppt/1755965698.pptx"}
                                width="100%"
                                height="600px"
                                frameborder="0"
                              ></iframe>
              </div> */}
              <div className="mt-3">
                <label className="addproduct-label">
                  Tags (Type point and press enter to add another point)
                </label>
                <TagsInput
                  value={searchtags}
                  onChange={(options) => {
                    setsearchtags(options);
                  }}
                  placeholder={"Enter Points"}
                  inputProps={{
                    className: "react-tagsinput-input",
                    placeholder: "",
                  }}
                  className="form-control tagsinputbox"
                />
              </div>

              <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    edithandle();
                  }}
                >
                  <p>Update</p>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <UserDetailsModal showmodal={showcandidatedetailsmodal} hidemodal={setshowcandidatedetailsmodal} candidateid={selectedcandidateidRef.current} />
      </div>
    );
}

export default Subscriptions